import {View} from "@lernetz/ts-lib";
import {languageService} from "../../services/lang";
import template from "./search-row.html";

export class SearchRow extends View {
    constructor() {
        super({ template, data: new SearchRowContorller() })
    }
    init() {
        this.data.router = this.context.router;
        this.data.currentLang = languageService.currentLang;
    }
}

class SearchRowContorller {
}
